import { DropdownItemImageAndIconBox } from '@bnnvara/hub';
import PropTypes from 'prop-types';
import React from 'react';

import resizeImageSource from '../../../../../helpers/resizeImageSource';
import { getIcon } from './getIcon';

const AccessoryLeft = ({ thumbnail, action }) => {
  if (!thumbnail) return null;

  return (
    <DropdownItemImageAndIconBox
      imgSrc={resizeImageSource(thumbnail.url, 80)}
      imgAltText={thumbnail.altText}
      IconComponent={getIcon(action)}
    />
  );
};

AccessoryLeft.propTypes = {
  thumbnail: PropTypes.shape(),
  action: PropTypes.string.isRequired,
};

export { AccessoryLeft };
